import { Menu } from '@mantine/core';
import { MenuContainer, DropDownContainer } from './PopupMenu.styles';

type PopupMenuProps = {
  targetContent: React.ReactNode;
  dropdownContent?: React.ReactNode;
};

const PopupMenu: React.FC<PopupMenuProps> = ({ targetContent, dropdownContent }) => {
  return (
    <MenuContainer>
      <Menu.Target>{targetContent}</Menu.Target>
      <DropDownContainer className="popupMenuDropdown">
        {dropdownContent}
      </DropDownContainer>
    </MenuContainer>
  );
};

export default PopupMenu;
